'use strict';

var _classCallCheck = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var defaultBase = self.location && self.location.protocol + '//' + self.location.host;
var URL = self.URL;

var URLWithLegacySupport =
/*#__PURE__*/
function () {
  function URLWithLegacySupport() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultBase;

    _classCallCheck(this, URLWithLegacySupport);

    this.super = new URL(url, base);
    this.path = this.pathname + this.search;
    this.auth = this.username && this.password ? this.username + ':' + this.password : null;
    this.query = this.search && this.search.startsWith('?') ? this.search.slice(1) : null;
  }

  _createClass(URLWithLegacySupport, [{
    key: "createObjectURL",
    value: function createObjectURL(o) {
      return this.super.createObjectURL(o);
    }
  }, {
    key: "revokeObjectURL",
    value: function revokeObjectURL(o) {
      this.super.revokeObjectURL(o);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.super.toJSON();
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.super.toString();
    }
  }, {
    key: "format",
    value: function format() {
      return this.toString();
    }
  }, {
    key: "hash",
    get: function get() {
      return this.super.hash;
    },
    set: function set(hash) {
      this.super.hash = hash;
    }
  }, {
    key: "host",
    get: function get() {
      return this.super.host;
    },
    set: function set(host) {
      this.super.host = host;
    }
  }, {
    key: "hostname",
    get: function get() {
      return this.super.hostname;
    },
    set: function set(hostname) {
      this.super.hostname = hostname;
    }
  }, {
    key: "href",
    get: function get() {
      return this.super.href;
    },
    set: function set(href) {
      this.super.href = href;
    }
  }, {
    key: "origin",
    get: function get() {
      return this.super.origin;
    },
    set: function set(origin) {
      this.super.origin = origin;
    }
  }, {
    key: "password",
    get: function get() {
      return this.super.password;
    },
    set: function set(password) {
      this.super.password = password;
    }
  }, {
    key: "pathname",
    get: function get() {
      return this.super.pathname;
    },
    set: function set(pathname) {
      this.super.pathname = pathname;
    }
  }, {
    key: "port",
    get: function get() {
      return this.super.port;
    },
    set: function set(port) {
      this.super.port = port;
    }
  }, {
    key: "protocol",
    get: function get() {
      return this.super.protocol;
    },
    set: function set(protocol) {
      this.super.protocol = protocol;
    }
  }, {
    key: "search",
    get: function get() {
      return this.super.search;
    },
    set: function set(search) {
      this.super.search = search;
    }
  }, {
    key: "searchParams",
    get: function get() {
      return this.super.searchParams;
    },
    set: function set(searchParams) {
      this.super.searchParams = searchParams;
    }
  }, {
    key: "username",
    get: function get() {
      return this.super.username;
    },
    set: function set(username) {
      this.super.username = username;
    }
  }]);

  return URLWithLegacySupport;
}();

function format(obj) {
  if (typeof obj === 'string') {
    var url = new URL(obj);
    return url.toString();
  }

  if (!(obj instanceof URL)) {
    var userPass = obj.username && obj.password ? "".concat(obj.username, ":").concat(obj.password, "@") : '';
    var auth = obj.auth ? obj.auth + '@' : '';
    var port = obj.port ? ':' + obj.port : '';
    var protocol = obj.protocol ? obj.protocol + '//' : '';
    var host = obj.host || '';
    var hostname = obj.hostname || '';
    var search = obj.search || (obj.query ? '?' + obj.query : '');
    var hash = obj.hash || '';
    var pathname = obj.pathname || '';
    var path = obj.path || pathname + search;
    return "".concat(protocol).concat(userPass || auth).concat(host || hostname + port).concat(path).concat(hash);
  }
}

module.exports = {
  URLWithLegacySupport: URLWithLegacySupport,
  URLSearchParams: self.URLSearchParams,
  defaultBase: defaultBase,
  format: format
};